import dagre from '@dagrejs/dagre'
import { type FlowEdge, type FlowNode, NODE_CARD_DEFAULT_HEIGHT, NODE_CARD_WIDTH, X_OFFSET, Y_OFFSET } from '@lighthouse/shared'
import { clone } from 'rambda'

export const getLayoutByDagre = (originNodes: FlowNode[], originEdges: FlowEdge[]) => {
    const dagreGraph = new dagre.graphlib.Graph()
    dagreGraph.setDefaultEdgeLabel(() => ({}))
    const nodes = clone(originNodes)
    const edges = clone(originEdges)
    dagreGraph.setGraph({
        rankdir: 'LR',
        align: 'UL',
        nodesep: Y_OFFSET,
        ranksep: X_OFFSET,
        ranker: 'tight-tree'
    })
    nodes.forEach(node => {
        dagreGraph.setNode(node.id, {
            width: node.measured?.width || NODE_CARD_WIDTH,
            height: node.measured?.height || NODE_CARD_DEFAULT_HEIGHT
        })
    })

    edges.forEach(edge => {
        dagreGraph.setEdge(edge.source, edge.target)
    })

    dagre.layout(dagreGraph)

    return dagreGraph
}
